import React, { useEffect, useState } from 'react';
import { getSliders } from "../api/auth/authService";
import Swal from 'sweetalert2';
function HeroSlider() {
	const [sliders, setSliders] = useState([]);

	useEffect(() => {
		const fetchSliderData = async () => {

			try {
				const response = await getSliders();
				setSliders(response);
			} catch (error) {
				console.error("Error fetching slider data:", error);
				Swal.fire("Error", "Failed to fetch slider data.", "error");
			}
		};
		fetchSliderData();

	}, []);

	return (
		<section className="slider">

			<div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000" >

				{/* Indicators */}
				<div className="carousel-indicators">
					{sliders.map((_, index) => (
						<button
							key={index}
							type="button"
							data-bs-target="#carouselExampleIndicators"
							data-bs-slide-to={index}

							className={index === 0 ? "active" : ""}
							aria-current={index === 0 ? "true" : undefined}

							aria-label={`Slide ${index + 1}`}
						></button>
					))}
				</div>

				{/* Slides */}
				<div className="carousel-inner">
					{sliders.map((item, index) => (
						<div
							key={item.id}

							className={`carousel-item ${index === 0 ? "active" : ""}`}
						>
							<img
								src={`data:image/jpeg;base64,${item.imageBytes}`}
								className="d-block w-100 img-fluid"
								alt={`Slide ${index + 1}`}
								style={{ maxHeight: "", objectFit: "" }}
							/>
							<div className="carousel-caption d-none d-md-block">
								{/* Optional caption */}
								{/* <h5>{item.title}</h5>
            <p>{item.description}</p> */}

							</div>
						</div>
					))}
				</div>

				{/* Controls */}
				<button
					className="carousel-control-prev"
					type="button"
					data-bs-target="#carouselExampleIndicators"
					data-bs-slide="prev"
				>
					<span className="carousel-control-prev-icon" aria-hidden="true"></span>
					<span className="visually-hidden">Previous</span>
				</button>
				<button
					className="carousel-control-next"
					type="button"
					data-bs-target="#carouselExampleIndicators"
					data-bs-slide="next"
				>

					<span className="carousel-control-next-icon" aria-hidden="true"></span>
					<span className="visually-hidden">Next</span>
				</button>
			</div>
		</section>




	);
}

export default HeroSlider;
